import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContactCardColumnWrapper } from "./ui";
import { ContactCard } from "@/components/contacting/ContactCard";
import { useContactingTestId } from "@/hooks";
import { useFeaturesEnabled } from "@/contexts/cdpConfig";
import { ContactModal } from "@/components/contacting/ContactModal";
import { ContactOpenedForm } from "@/components/contacting/ContactOpenedForm";
import { SuggestPriceModal } from "@/components/contacting/SuggestPrice/SuggestPriceModal";
export const ContactCardColumn = () => {
    const testId = useContactingTestId("ContactCardColumn");
    const { openedContactForm } = useFeaturesEnabled();
    return (_jsxs(ContactCardColumnWrapper, { testId: testId, children: [_jsx(ContactModal, {}), openedContactForm && _jsx(SuggestPriceModal, {}), openedContactForm ? _jsx(ContactOpenedForm, {}) : _jsx(ContactCard, {})] }));
};
